import { Chart, ChartArea, ChartCategoryAxis, ChartCategoryAxisItem, ChartLegend, ChartSeries, ChartSeriesItem, ChartTitle, ChartTooltip, RenderEvent, SeriesVisualArgs } from "@progress/kendo-react-charts";
import { Switch } from "@progress/kendo-react-inputs";
import { ExpansionPanel, ExpansionPanelContent } from "@progress/kendo-react-layout";
import "hammerjs";
import { Fragment, useEffect, useState } from "react";
import { Circle as CircleGeometry } from '@progress/kendo-drawing/geometry';
import { Layout, Text } from '@progress/kendo-drawing';
import moment from "moment";

export const WeeklyBreakDownPdf = (props: any) => {
    //for donut chart 
    const [totalHours, setTotalHours] = useState<any>();
    const [totalMinutes, setTotalMinutes] = useState<any>();
    const [notes, setNotes] = useState<any>([]);
    const [isDccExceededContract, setIsDccExceededContract] = useState<any>();
    const [isIccExceededContract, setIsIccExceededContract] = useState<any>();
    const [totalSessions, setTotalSessions] = useState<any>();
    const [weekCommencing, setWeekCommencing] = useState<any>();
    const [contractedSessions, setContractedSessions] = useState<any>();
    const [iccPercentage, setIccPercentage] = useState<any>();
    const [contractPercentage, setContractPercentage] = useState<any>();

    //for categories 
    const [categories, setCategories] = useState<any>([]);

    //for sub categories
    const [subCategories, setSubCategories] = useState<any>([]);

    //line chart
    const [lineChartCategories, setLineChartCategories] = useState<any>([]);

    //To get color for line chart
    const getColorForLineChart = (item: any) => {
        let map = new Map<number, string>();
        map.set(1, '#0967B1');
        map.set(2, '#DA1F6C');
        map.set(3, '#008E82');
        map.set(4, '#6F4F9B');
        map.set(5, '#EA580D');
        map.set(-888, 'grey');
        map.set(-999, '#FFDF00');

        if (item.isUserDefined) {
            return '#76A227'
        } else {
            return map.get(item.categoryId);
        }
    }

    //To map the catgories for line chart
    const mapSeries = (item: any, index : any) => {
        return (
            <ChartSeriesItem key={index} data={item.totalWorkHours} type="line"
                color={getColorForLineChart(item)}
                width={(item.categoryId === -999) || (item.categoryId === -888) ? 2 : 1}
                dashType={(item.categoryId === 1 || item.categoryId === 4 || item.isUserDefined) ? 'dash' : 'solid'}
                markers={{
                    size: ((item.categoryId === 1 || item.categoryId === -999 || item.categoryId === -888) ? 24 :
                        (item.categoryId === 2 || item.categoryId === 4) ? 15 :
                            (item.categoryId === 5 || item.isUserDefined) ? 9 :
                                (item.categoryId === 3) ? 30 : 24),
                    type: ((item.categoryId === 1 || item.categoryId === -999 || item.categoryId === -888) ? 'circle' :
                        (item.categoryId === 2 || item.categoryId === 4) ? 'square' :
                            (item.categoryId === 5 || item.isUserDefined) ? 'triangle' :
                                (item.categoryId === 3) ? 'cross' : 'circle'),
                    visible: (item.categoryId === -888) ? false : true,
                    background: "none"
                }}
            />
        );
    }

    useEffect(() => {
        BuildDataForCharts(props.data);
    },[])

    //to display categories for no data
    const weekWithNoCategoriesData = [{ id: 1, name: "", totalHours: 0, totalMinutes: 0, color: "rgb(191,191,191)", totalSessions: 1 }];

    //to display sub categories for no data
    const weekWithNoSubCategoriesData = [
        { id: 1, name: "", totalHours: 0, totalMinutes: 0, color: "rgb(191,191,191)", categoryId: 1, totalSessions: 0.4 },
        { id: 2, name: "", totalHours: 0, totalMinutes: 0, color: "rgb(191,191,191)", categoryId: 1, totalSessions: 0.3 },
        { id: 3, name: "", totalHours: 0, totalMinutes: 0, color: "rgb(191,191,191)", categoryId: 1, totalSessions: 0.2 },
        { id: 4, name: "", totalHours: 0, totalMinutes: 0, color: "rgb(191,191,191)", categoryId: 1, totalSessions: 0.1 }];

    let subCategoriesToSet: any = [];

    //to get colors for category
    const getColorForCategory = (category: any, subCategoriesList: any) => {
        let subcategories = subCategoriesList.filter((x: { categoryId: any; }) => x.categoryId == category.id);
        let total = 10 / subcategories.length;
        subcategories.forEach((element: any, index: any) => {
            let opacity = (total * (subcategories.length - index)) / 10;
            element.color = getColorForSubCategory(element, opacity);
            subCategoriesToSet.push(element);
        });

        let map: any = {
            1: '#0967B1',
            2: '#DA1F6C',
            3: '#008E82',
            4: '#6F4F9B',
            5: '#EA580D',
        };

        if (category.isUserDefined) {
            return '#76A227';
        } else {
            return map[category.id];
        }
    }

    //to get colors for sub category
    const getColorForSubCategory = (element: any, opacity: any) => {
        let alpha = opacity - 0.1;
        let map: any = {
            1: 'rgba(137, 207, 240,' + alpha + ')',
            2: 'rgba(218, 31, 108,' + alpha + ')',
            3: 'rgba(0, 142, 130,' + alpha + ')',
            4: 'rgba(111, 79, 155,' + alpha + ')',
            5: 'rgba(234, 88, 13,' + alpha + ')',
        };

        if (element.isUserDefined) {
            return 'rgba(118, 162, 39,' + alpha + ')';
        } else {
            return map[element.categoryId];
        }
    }

    //to build data for charts
    const BuildDataForCharts = (firstWeekdata: any) => {
        if (firstWeekdata?.totalSessions > 0) {
            firstWeekdata.weeklyBreakDownCategoryDtos.map((element: any) => {
                element.color = getColorForCategory(element, firstWeekdata.weeklyBreakDownSubCategoryDtos);
            });
            setTotalHours(firstWeekdata.totalHours);
            setTotalMinutes(firstWeekdata.totalMinutes);
            setTotalSessions(firstWeekdata.totalSessions);
            setNotes(firstWeekdata.notes);
            setWeekCommencing(firstWeekdata.weekCommencing);
            setIsDccExceededContract(firstWeekdata.dccTotal);
            setIsIccExceededContract(firstWeekdata.iccTotal);
            setContractedSessions(firstWeekdata.totalContractedSessions);
            setIccPercentage(firstWeekdata.totalIccPercentage);
            setContractPercentage(firstWeekdata.totalContractPercentage);
            setCategories(firstWeekdata.weeklyBreakDownCategoryDtos);
            setSubCategories(subCategoriesToSet);
            setLineChartCategories(firstWeekdata.lineChartCategoryDtos);
        } else {
            setTotalHours(0);
            setTotalMinutes(0);
            setTotalSessions(0);
            setNotes([]);
            setIsDccExceededContract(0);
            setIsIccExceededContract(0);
            setWeekCommencing(firstWeekdata.weekCommencing);
            setIccPercentage(0);
            setContractedSessions(0);
            setContractPercentage(0);
            setCategories(weekWithNoCategoriesData);
            setSubCategories(weekWithNoSubCategoriesData);
            setLineChartCategories([]);
        }
    }

    //to render donut center data
    let center: any;
    let radius: any;

    //To create visuals for donut chart center
    const visualHandler = (e: SeriesVisualArgs) => {
        // Obtain parameters for the segments
        center = e.center;
        radius = e.innerRadius;

        // Create default visual
        return e.createVisual();
    };

    //To render the donut chart center
    const onRender = (e: RenderEvent) => {
        // The center and radius are populated by now.
        // We can ask a circle geometry to calculate the bounding rectangle for us.
        if (center) {
            const circleGeometry = new CircleGeometry([center.x, center.y], radius);
            const bbox = circleGeometry.bbox();

            // Render the text
            const heading = new Text(totalHours + 'h ' + totalMinutes + 'm', [0, 0], {
                font: "bold 20px Helvetica Now,Helvetica,Arial,'sans- serif'",
            });

            // Reflow the text in the bounding box
            const layout = new Layout(bbox, {
                alignContent: "center",
                alignItems: "center",
                justifyContent: "center",
                spacing: 5,
                orientation: 'vertical'
            });

            layout.append(heading);
            layout.reflow();

            // Draw it on the Chart drawing surface
            if (e.target.surface) {
                e.target.surface.draw(layout);
            }
        }
    };

    //to set x axis values for line chart
    const weekRange = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    {props.weekIndex == 0 && (
                        <div className="col-lg-5 mb-2 p-0">
                            <div className="mb-0">
                                {props.isPublicHolidayToggleChecked && <Switch size="small" defaultChecked={true} onLabel={""} offLabel={""} />}
                                {!props.isPublicHolidayToggleChecked && <Switch size="small" defaultChecked={false} onLabel={""} offLabel={""} />}
                                <label className="form-check-label fs-5 ms-2">Exclude weeks with public holidays</label>
                            </div>
                            <div className="mb-0">
                                {props.isLeaveToggleChecked && <Switch size="small" defaultChecked={true} onLabel={""} offLabel={""} />}
                                {!props.isLeaveToggleChecked && <Switch size="small" defaultChecked={false} onLabel={""} offLabel={""} />}
                                <label className="form-check-label fs-5 ms-2">Exclude weeks with leave</label>
                            </div>
                            <div className="Container-fluid"></div><br />
                            <span className="text-muted fs-5">Weeks showing: {props.totalNumberOfWeeks}</span>
                        </div>
                    )}
                </div>
            </div>

            <p className="m-0">Week commencing {moment(weekCommencing).format('DD/MM/yyyy')}</p>
            {totalSessions > 0 && (
                <div className="Container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <Chart transitions={false}>
                                <ChartTitle text="hours" position="top" align="left" />
                                <ChartCategoryAxis>
                                    <ChartCategoryAxisItem
                                        title={{ text: "Day", position: "bottom" }}
                                        categories={weekRange}
                                    />
                                </ChartCategoryAxis>
                                <ChartSeries>
                                    {
                                        lineChartCategories.map(mapSeries)
                                    }
                                </ChartSeries>
                            </Chart>
                        </div>
                    </div>
                </div>
            )}
            <div className="Container-fluid">
                <div className="row">
                    <div className="col-lg-6">
                        {totalSessions == 0 && (
                            <p className="mt-0">No activities in diary for this week.</p>
                        )}
                        {totalSessions > 0 && (
                            <Chart transitions={false} onRender={onRender}>
                                <ChartTooltip background="#fff" />
                                <ChartLegend visible={false} />
                                <ChartArea background="none" />
                                <ChartSeries>
                                    <ChartSeriesItem visual={visualHandler}
                                        name="subCategories"
                                        width={500}
                                        type="donut"
                                        startAngle={0}
                                        field="totalSessions"
                                        categoryField="name"
                                        data={subCategories}
                                        colorField="color"
                                        size={40}
                                        holeSize={50}
                                        margin={3} >
                                    </ChartSeriesItem>
                                    <ChartSeriesItem visual={visualHandler}
                                        name="categories"
                                        width={500}
                                        type="donut"
                                        startAngle={0}
                                        field="totalSessions"
                                        categoryField="name"
                                        data={categories}
                                        colorField="color"
                                        size={60}
                                        holeSize={50}
                                        margin={3} >
                                    </ChartSeriesItem>
                                </ChartSeries>
                            </Chart>
                        )}
                    </div>
                    {totalSessions > 0 && (
                        <>
                            <div className="col-lg-2">
                            </div>
                            <div className="col-lg-4 mt-5">
                                {categories && categories.map((category: any, index: any) => (
                                    <Fragment key={index}>
                                        <ExpansionPanel
                                            expandIcon="k-icon k-i-arrow-60-right"
                                            collapseIcon="k-icon k-i-arrow-60-down"
                                            style={{ border: 'none', borderBottom: "2px solid lightgrey" }}
                                            expanded={true}
                                            tabIndex={0}
                                            key={category.id}
                                            title={
                                                <div className="row mt-2">
                                                    <span className="mr-2">
                                                        <svg width="50" height="50">
                                                            <circle cx="25" cy="25" r="25" fill={category.color} fillOpacity="0.3" />
                                                            <circle cx="25" cy="25" r="15" fill={category.color} fillOpacity="0.7" />
                                                            <circle cx="25" cy="25" r="5" fill={category.color} fillOpacity="1" />
                                                        </svg>
                                                        <label className="text-dark ps-2"><b>{category.name} - {category.totalHours?.toFixed(0)}h {category.totalMinutes?.toFixed(0)}m</b></label>
                                                    </span>
                                                </div>
                                            }
                                        />
                                        {subCategories.filter((x: any) => x.categoryId == category.id).map((subCategory: any, index: any) => (
                                            <Fragment key={index}>
                                                {true && (
                                                    <div className="container-fluid">
                                                        <ExpansionPanelContent >
                                                            <div className="row mt-2">
                                                                <span className="col-1 ps-4 ms-1">
                                                                    <svg width="20" height="20">
                                                                        <circle cx="10" cy="10" r="10" fill={subCategory.color} />
                                                                    </svg>
                                                                </span>
                                                                <label className="col-6 ps-4 ms-1">{subCategory.name}</label>
                                                                <label className="col-4 ps-3">{subCategory.totalHours?.toFixed(0)}h {subCategory.totalMinutes?.toFixed(0)}m</label>
                                                            </div>
                                                        </ExpansionPanelContent>
                                                    </div>
                                                )}
                                            </Fragment>
                                        ))}
                                    </Fragment>
                                ))}
                            </div>
                        </>
                    )}
                </div>

                {/* Notes data */}
                {notes.length > 0 && (
                    <div className="mt-4">
                        <div>
                            <h5 className="mb-1 text-dark">Notes for this week</h5>
                            {notes.map((item: any, index: any) => (
                                <div key={index}>
                                    <h5 className="text-muted mb-0">
                                        {moment(item.activityStartDate).format('DD/MM/yyyy')}{' '}
                                        {moment(item.activityStartDate).format('HH:mm')}-{moment(item.activityEndDate).format('HH:mm')}{' '}
                                        {item.categoryName}-{item.subCategoryName}<br />
                                    </h5>
                                    <span className="text-secondary">{item.notes}</span><br />
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                {contractedSessions > 0 && isDccExceededContract > contractedSessions ? (
                    <span className="red-text mb-2">
                        <svg width="16" height="16" fill="red" viewBox="0 0 16 16">
                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7z" />
                        </svg>&nbsp;
                        <p className="mb-2">Total DCC is more than contracted hours</p>
                    </span>
                ) : null}<br />
                {contractedSessions > 0 && (isDccExceededContract && isIccExceededContract > contractedSessions) ? (
                    <span className="red-text mb-2">
                        <svg width="16" height="16" fill="red" viewBox="0 0 16 16">
                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7z" />
                        </svg>&nbsp;
                        <p className="mb-2">Total DCC and ICC is more than contract hours.</p>
                    </span>
                ) : null}
                {iccPercentage > 0 ? (
                    <p className="mb-1">Your ICC is {iccPercentage.toFixed(0)}% of your DCC plus ICC time.</p>) : null}
                {contractPercentage > 0 ? (
                    <p>Your contract hours are {contractPercentage.toFixed(0)}% of your worked total.</p>
                ) : null}
            </div>
        </>
    );
} 